export interface TaskRequestHoursClass {
AccountTaskRequestId :number
AccountId:number
AccountProjectTaskId:number
SystemTaskRequestTypeId	:number
LastAllocationHours	: number
NewAllocationHours	:number
Description : string
AccountEmployeeId : number
IsApproved: boolean
IsRejected:	boolean
ApprovedOn:Date | undefined
RejectedOn:Date | undefined
CreatedBy	:number
CreatedOn:Date | undefined
ModifiedBy:number
ModifiedOn	:Date | undefined
isSelected:number
Status:string
Comments:string
Approved:boolean
Rejected:boolean
}

export const taskRequestHoursForAdd = {
AccountId:0,
SystemTaskRequestTypeId	:0,
LastAllocationHours	: 0,
NewAllocationHours	:0,
Description : "",
AccountEmployeeId : 0,
IsApproved: false,
IsRejected:	false,
ApprovedOn:new Date(),
RejectedOn:new Date(),
CreatedBy	:0,
CreatedOn:new Date(),
ModifiedBy:0,
ModifiedOn	:new Date()
}


export const taskRequestHoursForUpdate = {
    AccountTaskRequestId:0,
    AccountId:0,
    SystemTaskRequestTypeId	:0,
    LastAllocationHours	: 0,
    NewAllocationHours	:0,
    Description : "",
    AccountEmployeeId : 0,
    IsApproved: false,
    IsRejected:	false,
    ApprovedOn:new Date(),
    RejectedOn:new Date(),
    CreatedBy	:0,
    CreatedOn:new Date(),
    ModifiedBy:0,
    ModifiedOn	:new Date()
}
